// src/components/companion/MarlowAvatar.jsx
//
// Marlow's mark. Deliberately draws NOTHING from the network until artwork
// actually exists in this repo.
//
// The reason is a bug this app's sibling just shipped: Profound Thinking's
// ClaraAvatar hardcoded /images/clara.webp while no such file was committed.
// Hosting rewrites ** to /index.html and the .webp header rule matches on
// request path, so that URL served the SPA's HTML tagged
// `immutable, max-age=31536000` — a wrong response pinned at the edge for a
// year, on a path we cannot purge. Pointing at a file that is not there is not
// a harmless placeholder; it burns the URL.
//
// Artwork arrived 2026-08-29, so ARTWORK is now set. The path was checked
// against that rule before being used: nothing had ever requested
// /images/marlow.webp — the app had no companion UI at all until this feature,
// and the hub's stale entry pointed at /images/characters/marlow.webp — so the
// URL is virgin and cannot be serving a pinned HTML fallback.
//
// If this ever needs replacing, ship the new file under a NEW name rather than
// overwriting: the old path stays cached at the edge for a year.
import React, { useState } from 'react';

const ARTWORK = '/images/marlow.webp';

const MarlowAvatar = ({ size = 40, className = '' }) => {
  const [failed, setFailed] = useState(false);
  const px = { width: size, height: size };

  if (ARTWORK && !failed) {
    return (
      <img
        src={ARTWORK}
        alt=""
        style={px}
        className={`rounded-full object-cover flex-shrink-0 border border-amber-400/40 ${className}`}
        onError={() => setFailed(true)}
        aria-hidden="true"
      />
    );
  }

  // Fallback for a slow or failed load: an "M" in campfire amber on deep slate,
  // the app's own palette, so a miss reads as a considered mark rather than a
  // broken-image glyph.
  return (
    <div
      style={px}
      className={`rounded-full bg-slate-900 border border-amber-400/40 flex items-center justify-center flex-shrink-0 ${className}`}
      aria-hidden="true"
    >
      <span
        className="font-secondary text-amber-400 font-semibold"
        style={{ fontSize: size * 0.5, lineHeight: 1 }}
      >
        M
      </span>
    </div>
  );
};

export default MarlowAvatar;
